module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_vm._l((_vm.active), function(item) {
    return _c('div', {
      staticClass: "promotions-item"
    }, [_c('router-link', {
      attrs: {
        "tag": "div",
        "to": {
          name: 'MarketingDetail',
          query: {
            id: item.activityId,
            contentId: item.contentMarketingId,
            brand: item.brandNameCn
          }
        }
      }
    }, [_c('div', {
      staticClass: "promotions-item-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.titlePicture
      },
      on: {
        "error": function($event) {
          return _vm.error(3)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "promotions-item-content"
    }, [_c('router-link', {
      attrs: {
        "tag": "div",
        "to": {
          name: 'MarketingDetail',
          query: {
            id: item.activityId,
            contentId: item.contentMarketingId,
            brand: item.brandNameCn
          }
        }
      }
    }, [_c('div', {
      staticClass: "marketing-item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "promotions-item-richTxt"
    }, [_vm._v(_vm._s(item.content))])]), _vm._v(" "), _c('div', {
      staticClass: "font-right promotions-update-time"
    }, [_vm._v("发布方：" + _vm._s(item.brandNameCn) + " 时间：" + _vm._s(item.updateTime) + "\n\t\t\t\t\t\t"), _c('a', {
      staticClass: "marketing-download",
      attrs: {
        "href": item.richTxtPath
      }
    })])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.condition.pageNum,
      "total": _vm.total,
      "page-size": 30
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      }
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13e4b4d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Marketing.vue
// module id = 516
// module chunks = 1